import React from 'react';
import Grid from '@mui/material/Grid';
import { GridSection, GridLeft, GridRight } from '../../../Episode.Styled';
import {
  CalOMSAdmitSubHeading,
  CheckboxGridItems,
  CheckboxGridItemsWithField,
  InputFieldGridItems,
} from '../AuthTabCommonUtils';
import {
  drugUsedDays,
  getNotApplicableYesNo,
  primaryAlcoholProblem,
  referalSource,
  routeOfAdministration,
  serviceTypes,
  transactionTypes,
  waitingDays,
} from '../authTabConstants';
import {
  adm2,
  adm3,
  adm4,
  adm5,
  adm6,
  adm7,
  adm8,
  adm9,
  adm10,
  adu1a,
  adu1b,
  adu2,
  adu3,
  adu4,
} from './CalOMSQuestionnaireConstants';
import { useSelector } from 'react-redux';

const PageTwoCalOMS = () => {
  const getCalOMSAdmitPdfForm = useSelector(
    (state) => state?.calOMSAdmitPdfForm?.data
  );
  const {
    caAdmTyp,
    caWaitList,
    caCalWorks,
    caCalWorksSub,
    caPriDrug,
    caPriDrugName,
    caPriDrugUse,
    caPriDrugAdm,
    caPriDrugAge,
  } = getCalOMSAdmitPdfForm || {};

  transactionTypes?.forEach((type, index) => {
    type.checked = caAdmTyp === index ? true : false;
  });

  const getCalworkYesNo = getNotApplicableYesNo?.map(
    (getNotApplicableYesNo, index) => ({
      ...getNotApplicableYesNo,
      checked: caCalWorks === index ? true : false,
    })
  );

  const getCalworkSubstance = getNotApplicableYesNo?.map(
    (getNotApplicableYesNo, index) => ({
      ...getNotApplicableYesNo,
      checked: caCalWorksSub === index ? true : false,
    })
  );

  const getWaitingDay = waitingDays?.map((waitingDays, index) => ({
    ...waitingDays,
    checked: caWaitList === index ? true : false,
  }));

  const getPrimaryDrug = primaryAlcoholProblem?.map(
    (primaryAlcoholProblem, index) => ({
      ...primaryAlcoholProblem,
      checked: caPriDrug === index ? true : false,
    })
  );

  const getPrimaryDrugUseDays = drugUsedDays?.map((drugUsedDays, index) => ({
    ...drugUsedDays,
    checked: caPriDrugUse === index ? true : false,
  }));

  const getPrimaryDrugAdm = routeOfAdministration?.map(
    (routeOfAdministration, index) => ({
      ...routeOfAdministration,
      checked: caPriDrugAdm === index ? true : false,
    })
  );

  return (
    <Grid container>
      <GridSection mx={2} item container spacing={1}>
        <GridLeft item container xs={6}>
          <CalOMSAdmitSubHeading title="Admission Information" />

          <CheckboxGridItems
            heading="ADM-2"
            data={transactionTypes}
            text={adm2}
          />

          <InputFieldGridItems heading="ADM-3" value="" text={adm3} />

          <CheckboxGridItems heading="ADM-4" data={serviceTypes} text={adm4} />

          <CheckboxGridItems heading="ADM-5" data={referalSource} text={adm5} />

          <CheckboxGridItems heading="ADM-6" data={getWaitingDay} text={adm6} />

          <CheckboxGridItems heading="ADM-7" data={waitingDays} text={adm7} />

          <CheckboxGridItems
            heading="ADM-8"
            data={getCalworkYesNo}
            text={adm8}
          />

          <CheckboxGridItems
            heading="ADM-9"
            data={getCalworkSubstance}
            text={adm9}
          />

          <CheckboxGridItemsWithField
            heading="ADM-10"
            data={getNotApplicableYesNo}
            text={adm10}
            value=""
          />
        </GridLeft>

        <GridRight item container xs={6}>
          <CalOMSAdmitSubHeading title="Alcohol and Other Drug Use" />

          <CheckboxGridItems
            heading="ADU-1A"
            data={getPrimaryDrug}
            text={adu1a}
          />

          <InputFieldGridItems
            heading="ADU-1B"
            value={caPriDrugName}
            text={adu1b}
          />

          <CheckboxGridItems
            heading="ADU-2"
            data={getPrimaryDrugUseDays}
            text={adu2}
          />

          <CheckboxGridItems
            heading="ADU-3"
            data={getPrimaryDrugAdm}
            text={adu3}
          />

          <InputFieldGridItems
            heading="ADU-4"
            value={caPriDrugAge}
            text={adu4}
          />
        </GridRight>
      </GridSection>
    </Grid>
  );
};

export default PageTwoCalOMS;
